import { decode } from "jsonwebtoken";
import SessionManager from "../../../../shared/util/services/auth/SessionManager";
import {
  checkAuthTokenExists,
  isJson,
} from "../../../../shared/util/services/auth/AuthService";

export const getUsername = () => {
  let username = "";

  if (checkAuthTokenExists()) {
    const decodedIdToken = decode(SessionManager.getIdToken(), {
      json: true,
    });

    const { profile } = decodedIdToken;

    if (profile && isJson(profile)) {
      username = JSON.parse(profile).name;
    }
  }

  return username;
};

export const getPartnerScorecardId = () => {
  let partnerScorecardId = "";

  if (checkAuthTokenExists()) {
    const decodedIdToken = decode(SessionManager.getIdToken(), {
      json: true,
    });

    const { profile } = decodedIdToken;

    if (profile) {
      partnerScorecardId = JSON.parse(profile).partnerScorecardId;
    }
  }

  return partnerScorecardId;
};
